// Estos diagnósticos se conservan en el reporte, sin mostrarlos al usuario.
export const visibleVipWarnings = (report) =>
  (report?.warnings || []).filter(
    (warning) =>
      !warning.startsWith(
        "Vista preliminar: los tiempos actuales contienen solo el último registro por placa;"
      ) && !/^\d+ eventos llegaron fuera del rango solicitado y fueron excluidos\./.test(warning)
  );
